import { get, post, put, deleted } from '..';
import routes from './routes';

const SizeServices = {
  createSize: async (obj) => {
    const data = await post(routes.createSize, obj);
    return data;
  },
  getSizes: async (params) => {
    const data = await get(routes.getSizes, params);
    return data;
  },
  getSizeById: async (id) => {
    const data = await get(routes.getSizeById + id);
    return data;
  },
  updateSize: async (id, obj) => {
    const data = await put(routes.updateSize + id, obj);
    return data;
  },
  deleteSize: async (id) => {
    const data = await deleted(routes.deleteSize + id);
    return data;
  },
}

export default SizeServices